@if (addedItem) {
<div class="p-l-1 p-r-1">
    <div class="bg-col-w pos-relative">
        <!-- close -->
        <button class="pos-absolute p-a top-0 right-0"
                type="button"
                [attr.aria-label]="'Close' | translate"
                (click)="close()">
            <i class="icon-close"
               aria-hidden="true"></i>
        </button>
        <div class="_container">
            <div class="p-a p-t-8">
                @switch (addedItemsQty > 1) {
                @case (false) {
                <!-- title -->
                <h4 class="h4 col-11 m-b">{{'Added to your bag' | translate}}</h4>
                <basket-add-notice-item class="w-12"
                                        (productRemoved)="close()"
                                        [item]="addedItem"></basket-add-notice-item>

                @if (addedGiftItem) {
                <basket-add-notice-item class="w-12 m-t"
                                        [item]="addedGiftItem"></basket-add-notice-item>
                }
                }
                @default {
                <h4 class="h4 center col-11 m-b">{{'Items have been added to your bag' | translate}}</h4>
                }
                }
            </div>
            @if (content?.klevu_recommendations_id) {
            <basket-related-products class="block m-b-5"
                                     [limit]="10"
                                     [source]="addedItem.product.id"
                                     [options]="relatedProductsOptions">
            </basket-related-products>
            }

            <icms-outlet-block class="block m-b-2"
                               [name]="'Minibasket ac'"
                               [variant]="'minibasket-ac'"
                               [allowOnly]=" ['advanced-commerce']"></icms-outlet-block>
        </div>
        <!-- go to checkout button -->
        <div class="b-t b-w-2 b-col-52 p-a">
            <a class="w-12 button"
               routerLink="/checkout"
               [attr.aria-label]="'Close' | translate"
               (click)="close()">
                <span>
                    {{ 'Go to Checkout' | translate}}
                    {{basket.qty ? ' (' + basket.qty + ' ' + (basket.qty > 1 ? ('items' | translate) : ('item' |
                    translate)) + ') ' : '' }}
                </span>
            </a>
        </div>
    </div>
</div>
}